<template>
  <v-dialog
    :model-value="modelValue"
    width="700"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white py-5 pl-10">
          BAST Garansi IMKP
        </h2>
      </div>

      <div class="px-10 py-5">
        <div v-if="loading" class="py-10 text-center text-gray-500">
          Memuat data BAST Garansi…
        </div>

        <template v-else>
          <v-form ref="formBastGaransi" @submit.prevent="handleSubmit">
            <div class="mb-4">
              <p class="text-xs font-semibold text-gray-500 mb-1">
                Judul Proyek
              </p>
              <p class="text-sm font-medium text-gray-800">
                {{ judulProyek || "-" }}
              </p>
            </div>

            <template v-if="isEditable">
              <v-file-input
                v-model="fileGaransi.file"
                label="Upload File BAST Garansi"
                accept=".pdf"
                variant="outlined"
                density="compact"
                color="#475569"
                prepend-icon=""
                prepend-inner-icon="mdi-cloud-upload-outline"
                multiple
                chips
                hide-details="auto"
                :rules="formValidasi.file"
                @update:model-value="onFileChange"
              />
              <p class="text-xs text-red-600 font-medium mt-1">
                * Proyek ini membutuhkan Berita Acara Serah Terima (BAST)
                Garansi.
              </p>
            </template>

            <div
              v-if="fileGaransi.assets.length >= 1"
              class="text-sm my-3 font-medium"
            >
              <span>File saat ini :</span>
              <ul class="mt-1">
                <li v-for="(file, index) in fileGaransi.assets" :key="index">
                  <a
                    class="text-red-600 font-normal cursor-pointer"
                    style="text-decoration: none"
                    @click="downloadFile(file, formatFilename)"
                  >
                    File BAST Garansi_{{ index + 1 }}.pdf
                  </a>
                </li>
              </ul>
            </div>

            <div class="flex justify-end gap-3 mt-5">
              <FormButton
                label="Tutup"
                variant="outlined"
                classes="capitalize text-gray-500"
                @click="closeModal"
              />
              <FormButton
                v-if="isEditable"
                label="Simpan"
                classes="bg-red-600 text-white capitalize"
                @click="handleSubmit"
              />
            </div>
          </v-form>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    img="warning.png"
    title="BAST Garansi IMKP"
    description="Apakah anda yakin akan melakukan BAST Garansi IMKP ini?"
    wording-cancel="Batal"
    wording-confirm="Ya"
    :loading="submitting"
    @close-modal="dialogConfirm = false"
    @confirm-data="submitGaransi"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormButton from "@/components/FormButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import axios from "axios";
import {
  API_BASE_URL,
  CMS_IMKP_DETAIL,
  CMS_SET_BAST_WARRANTY,
} from "@/constants";
import { statusIMKPEnum, levelEnum } from "@/utilities/enum";
import { downloadFile } from "@/utilities/globalFunction";
import UploadFileService from "@/utilities/upload-file";
import { FormValidasiImkp } from "@/pages/imkp/core/FormData";
import util from "@/assets/js/util";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_garansi = API_BASE_URL + CMS_SET_BAST_WARRANTY;
const max_file_size = 5;

export default {
  name: "BastWarrantyImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
    ConfirmModal,
  },
  emits: ["update:modelValue", "submitted"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
    status: { type: [Number, String], default: null },
    judulProyek: { type: String, default: "" },
    namaKontraktor: { type: String, default: "" },
  },
  data() {
    return {
      statusIMKPEnum,
      loading: false,
      submitting: false,
      dialogConfirm: false,
      fileGaransi: {
        file: [],
        assets: [],
      },
      formatFilename: "",
    };
  },
  computed: {
    userRole() {
      return Array.isArray(this.userData.role) ? "isafe" : this.userData.role;
    },
    isEditable() {
      return (
        (this.status === statusIMKPEnum.BAST_WARRANTY &&
          this.fileGaransi.assets.length === 0) ||
        this.status === statusIMKPEnum.BAST_WARRANTY_REVISION
      );
    },
    formValidasi() {
      return {
        file: FormValidasiImkp.filePersyaratanKhusus,
      };
    },
  },
  created() {
    this.uploadFileService = new UploadFileService(
      this.userData.token,
      this.userRole,
    );
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.fetchDetail();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    downloadFile,
    resetForm() {
      this.fileGaransi = { file: [], assets: [] };
      this.formatFilename = "";
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.$refs.formBastGaransi?.resetValidation();
      });
    },
    async handleSubmit() {
      const { valid } = await this.$refs.formBastGaransi.validate();
      if (!valid) return;
      this.dialogConfirm = true;
    },
    async fetchDetail() {
      if (!this.imkpId) return;
      try {
        this.loading = true;
        const result = await axios.get(url_imkp_detail, {
          params: { id: this.imkpId },
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        const res = result.data.data[0];
        this.fileGaransi.assets = res?.fileBastWarranty
          ? JSON.parse(res.fileBastWarranty)
          : [];
        this.formatFilename =
          "File BAST Garansi " + this.judulProyek + "-" + this.namaKontraktor;
      } catch (error) {
        console.log("ERR fetchDetail BAST Garansi : ", error);
        util.showError("Terjadi kesalahan saat memuat data BAST Garansi.");
      } finally {
        this.loading = false;
      }
    },
    onFileChange(files) {
      const arrFile = Array.isArray(files) ? files : files ? [files] : [];
      const invalid = arrFile.find(
        (item) =>
          item.type !== "application/pdf" ||
          item.size > max_file_size * 1024 * 1024,
      );

      if (invalid) {
        if (invalid.type !== "application/pdf") {
          util.showError("Ekstensi file harus .pdf!");
        } else {
          util.showError(
            "Ukuran file melebihi batas max " + max_file_size + "MB !",
          );
        }
        this.fileGaransi.file = [];
        return;
      }

      this.fileGaransi.file = arrFile;
    },
    async uploadFiles() {
      this.fileGaransi.assets = [];
      for (const file of this.fileGaransi.file) {
        try {
          const res = await this.uploadFileService.uploadFile(file);
          this.fileGaransi.assets.push(res.filename);
        } catch (error) {
          util.showError("Terjadi kesalahan saat upload file!");
        }
      }
    },
    async submitGaransi() {
      try {
        this.submitting = true;
        await this.uploadFiles();

        const bodyJson = {
          id: this.imkpId,
          kontraktorId: parseInt(this.userData.kontraktorID),
          usecase: levelEnum.KONTRAKTOR,
          fileBastWarranty: JSON.stringify(this.fileGaransi.assets),
        };

        await axios.post(url_garansi, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        util.showInfo("BAST garansi IMKP berhasil!", 2000);
        this.dialogConfirm = false;
        this.$emit("submitted");
        this.closeModal();
      } catch (error) {
        console.log("ERR submitGaransi : ", error);
        util.showError("Terjadi kesalahan saat submit BAST garansi IMKP!");
      } finally {
        this.submitting = false;
      }
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>
